import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { Filters_DEPRECATED } from '~/components/Shared/Filters_DEPRECATED/Filters_DEPRECATED';
import { Field } from '~/components/Shared/Filters_DEPRECATED/types';
import { Filter } from '~/evifields/src/types/Filter';
import { api } from '~/redux/api/createApi';
import { slices } from '~/redux/slices';

import { getFields } from '../utils';

interface Props {
  filters: Filter[];
  onChange: (updatedFilters: Filter[]) => void;
}

export const AttemptsFilters = ({ filters, onChange }: Props) => {
  const intl = useIntl();
  const selectAllEndpoints = useSelector(
    slices.webhooks.selectors.selectAllEndpoints,
  );

  const { data: eventGroups = [], isLoading: isLoadingEvents } =
    api.endpoints.getEventFields.useQuery(undefined);

  const fields: Record<string, Field> = useMemo(
    () =>
      getFields({
        eventGroups,
        endpoints: selectAllEndpoints,
        intl,
      }),
    [eventGroups, isLoadingEvents, selectAllEndpoints],
  );

  return (
    <Filters_DEPRECATED
      fields={fields}
      filters={filters}
      groups={[]}
      options={{
        showInlineManageFilters: true,
        disableManageFilters: true,
        disableRemoveFilter: true,
      }}
      onChange={onChange}
    />
  );
};
